var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { fontWeights } from 'syf-component-library/defaultTheme';
import theme from '../../theme';
var Link = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: ", ";\n  text-decoration: none;\n"], ["\n  color: ", ";\n  font-weight: ", ";\n  text-decoration: none;\n"])), theme.colors.denimBlue, fontWeights.bold);
export default Link;
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map